module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDkuMTQyODZIOS4xNDI4NlYxNkg2Ljg1NzE0VjkuMTQyODZIMFY2Ljg1NzE0SDYuODU3MTRWMEg5LjE0Mjg2VjYuODU3MTRIMTZWOS4xNDI4NloiIGZpbGw9IiMwMDAiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homebase/bookmarks/add.svg
// module id = xE+4
// module chunks = 1